import { Box } from '@mui/material';
import { useRouter } from 'src/routes/hooks';
import Iconify from '../iconify';

export default function BackButton() {
  const router = useRouter();
  // const location = useLocation();

  // if (location.key === 'default') {
  //   return null;
  // }

  return (
    <Box
      sx={{ cursor: 'pointer', mb: 2, color: 'text.secondary', opacity: 0.72 }}
      onClick={() => router.back()}
    >
      <Iconify icon="solar:arrow-left-outline" sx={{ width: 24, height: 24 }} />
    </Box>
  );
}
